// import Vue from "vue";
import ArrowLeft from "./components/arrow-left";
import Edit from "./components/edit";
import List from "./components/list";
import Menu from "./components/menu";
import Plus from "./components/plus";
import Power from "./components/power";
import RefreshCw from "./components/refresh-cw";
import Trash from "./components/trash";
import UploadCloud from "./components/upload-cloud";
// os
import Android from "./components/android";
import AndroidGray from "./components/android-gray";
import Alpinelinux from "./components/alpinelinux";
import AlpinelinuxGray from "./components/alpinelinux-gray";
import AppleBrand from "./components/apple-brand";
import AppleBrandGray from "./components/apple-brand-gray";
import Archlinux from "./components/archlinux";
import ArchlinuxGray from "./components/archlinux-gray";
import Centos from "./components/centos";
import CentosGray from "./components/centos-gray";
import Debian from "./components/debian";
import DebianGray from "./components/debian-gray";
import Deepin from "./components/deepin";
import DeepinGray from "./components/deepin-gray";
import Kali from "./components/kali-linux";
import Linux from "./components/linux";
import LinuxGray from "./components/linux-gray";
import LinuxMint from "./components/linux-mint";
import LinuxMintGray from "./components/linux-mint-gray";
import Opensuse from "./components/opensuse";
import OpensuseGray from "./components/opensuse-gray";
import Openwrt from "./components/openwrt";
import OpenwrtGray from "./components/openwrt-gray";
import Qnap from "./components/qnap";
import QnapGray from "./components/qnap-gray";
import Raspberry from "./components/raspberry";
import RaspberryGray from "./components/raspberry-gray";
import Redhat from "./components/redhat";
import RedhatGray from "./components/redhat-gray";
import Synology from "./components/synology";
import SynologyGray from "./components/synology-gray";
import Ubuntu from "./components/ubuntu";
import UbuntuGray from "./components/ubuntu-gray";
import Windows10 from "./components/windows10";
import Windows10Gray from "./components/windows10-gray";
import Windows7 from "./components/windows7";
import Windows7Gray from "./components/windows7-gray";


const featherIcons = {
    ArrowLeft,
    Edit,
    List,
    Menu,
    Plus,
    Power,
    RefreshCw,
    Trash,
    UploadCloud,
    // os
    Android,
    AndroidGray,
    Alpinelinux,
    AlpinelinuxGray,
    AppleBrand,
    AppleBrandGray,
    Archlinux,
    ArchlinuxGray,
    Centos,
    CentosGray,
    Debian,
    DebianGray,
    Deepin,
    DeepinGray,
    Kali,
    Linux,
    LinuxGray,
    LinuxMint,
    LinuxMintGray,
    Opensuse,
    OpensuseGray,
    Openwrt,
    OpenwrtGray,
    Qnap,
    QnapGray,
    Raspberry,
    RaspberryGray,
    Redhat,
    RedhatGray,
    Synology,
    SynologyGray,
    Ubuntu,
    UbuntuGray,
    Windows10,
    Windows10Gray,
    Windows7Gray,
    Windows7,
};

featherIcons.install = (app) => {
    for (const key in featherIcons) {
        app.component("Feather" + key, featherIcons[key]);
    }
};

export default featherIcons;
